import { createFileRoute, notFound } from '@tanstack/react-router'

import { isOuisenseUser } from '@/hooks/use-is-ouisense-user'

// Garde de la section admin : seuls les utilisateurs OuiSense y accèdent. Pour tout autre utilisateur
// on renvoie une 404 (et non un 403) afin de ne pas révéler l'existence de la section. Couvre /admin
// et toutes ses sous-routes via le layout.
export const Route = createFileRoute('/_dashboard/admin')({
  beforeLoad({ context }) {
    if (!isOuisenseUser(context.user)) {
      throw notFound()
    }
  },
})
